export const T = {
  en_GB: {
    ssnPlaceholder: "e.g., 04028892518",
    ssnNationalId: "SSN / National ID",
    dateOfBirth: "Date of birth",
    identifyBy: "Identify by",
    willSearchAs: "Will search as",
  },
  nb_NO: {
    ssnPlaceholder: "f.eks. 04028892518",
    ssnNationalId: "Fødselsnummer / Nasjonal ID",
    dateOfBirth: "Fødselsdato",
    identifyBy: "Identifiser med",
    willSearchAs: "Vil søke som",
  },
} as const;
